import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

// Cartão de prévia de link dentro da bolha, no padrão do WhatsApp Web.
const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  return {
    card: {
      display: "flex",
      alignItems: "stretch",
      // Ocupa a largura da bolha (o texto reserva 62px à direita para a hora) sem alargá-la:
      // largura 0 não entra na conta do tamanho da bolha; o mínimo garante um cartão legível
      // quando o texto é curto.
      width: 0,
      minWidth: "max(240px, calc(100% + 62px))",
      margin: "0 -62px 6px -4px",
      borderRadius: 6,
      overflow: "hidden",
      backgroundColor: isDark ? "rgba(11,20,26,0.35)" : "rgba(11,20,26,0.06)",
      color: "inherit",
      textDecoration: "none",
      whiteSpace: "normal",
      "&:hover": { backgroundColor: isDark ? "rgba(11,20,26,0.5)" : "rgba(11,20,26,0.1)" },
      "&:focus-visible": { outline: "2px solid #53bdeb", outlineOffset: 1 },
    },
    thumb: {
      flex: "none",
      width: 84,
      minHeight: 84,
      objectFit: "cover",
      backgroundColor: isDark ? "rgba(255,255,255,0.06)" : "rgba(11,20,26,0.06)",
    },
    text: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: 2,
      padding: "7px 10px 8px",
    },
    title: {
      fontSize: 13.5,
      lineHeight: "18px",
      fontWeight: 500,
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      wordBreak: "break-word",
    },
    description: {
      fontSize: 12.5,
      lineHeight: "17px",
      color: isDark ? "rgba(233,237,239,0.6)" : "#667781",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      wordBreak: "break-word",
    },
    host: {
      fontSize: 11.5,
      lineHeight: "15px",
      color: isDark ? "rgba(233,237,239,0.45)" : "#8696a0",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };
});

const LinkPreviewCard = ({ preview }) => {
  const classes = useStyles();
  const [thumbFailed, setThumbFailed] = useState(false);
  if (!preview) return null;

  return (
    <a
      className={classes.card}
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      onDoubleClick={(e) => e.stopPropagation()}
      data-link-preview="true"
    >
      {preview.thumbnail && !thumbFailed && (
        <img className={classes.thumb} src={preview.thumbnail} alt="" onError={() => setThumbFailed(true)} />
      )}
      <span className={classes.text}>
        {preview.title && <span className={classes.title}>{preview.title}</span>}
        {preview.description && <span className={classes.description}>{preview.description}</span>}
        <span className={classes.host}>{preview.host}</span>
      </span>
    </a>
  );
};

export default LinkPreviewCard;
